import React, { lazy } from 'react';
import { PERMISSIONS } from '@auth/permissions';
import { RequirePermission } from '@routes/RequirePermission';
import { Navigate, Route } from 'react-router';

const RolesOverview = lazy(() =>
  import('@pages/Management/Authorization/RolesOverview').then((m) => ({
    default: m.RolesOverview,
  }))
);

const UpsertRole = lazy(() =>
  import('@pages/Management/Authorization/UpsertRole').then((m) => ({
    default: m.UpsertRole,
  }))
);

const RoleDetails = lazy(() =>
  import('@pages/Management/Authorization/RoleDetails').then((m) => ({
    default: m.RoleDetails,
  }))
);

const EditRolePermissions = lazy(() =>
  import('@pages/Management/Authorization/EditRolePermissions').then((m) => ({
    default: m.EditRolePermissions,
  }))
);

export const manageMembersRoles = (
  <Route element={<RequirePermission permission={PERMISSIONS.roles.view} />}>
    <Route path="roles-and-permissions">
      <Route index element={<Navigate to="roles" replace />} />

      <Route path="roles">
        <Route index element={<RolesOverview />} />

        <Route
          element={<RequirePermission permission={PERMISSIONS.roles.create} />}
        >
          <Route path="new" element={<UpsertRole />} />
        </Route>

        <Route path="edit/:id/permissions" element={<EditRolePermissions />} />

        <Route
          element={<RequirePermission permission={PERMISSIONS.roles.update} />}
        >
          <Route path="edit/:id" element={<UpsertRole />} />
        </Route>

        <Route path=":id" element={<RoleDetails />} />
      </Route>
    </Route>
  </Route>
);
